import { render } from "./PrintReceiptPage.vue?vue&type=template&id=0f173d9a&scoped=true"
import script from "./PrintReceiptPage.vue?vue&type=script&lang=js"
export * from "./PrintReceiptPage.vue?vue&type=script&lang=js"

import "./PrintReceiptPage.vue?vue&type=style&index=0&id=0f173d9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f173d9a"]])

export default __exports__